import {
  PreferenceFormPreferences,
  PreferenceFormSubmission,
  Subscriber,
} from '../types/subscribers';

async function readErrorMessage(
  response: Response,
  fallback: string,
): Promise<string> {
  try {
    const body = await response.json();
    return body?.details || body?.error || fallback;
  } catch {
    return fallback;
  }
}

function preferenceFormUrl(tokenValue: string): string {
  return `/api/preferences/${encodeURIComponent(tokenValue)}`;
}

export async function fetchPreferenceForm(
  tokenValue: string,
): Promise<PreferenceFormPreferences> {
  const response = await fetch(preferenceFormUrl(tokenValue), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    credentials: 'omit',
  });

  if (!response.ok) {
    throw new Error(
      await readErrorMessage(response, 'Unable to load preferences'),
    );
  }

  return await response.json();
}

export async function submitPreferenceForm(
  tokenValue: string,
  submission: Omit<PreferenceFormSubmission, 'preferenceFormToken'>,
): Promise<Subscriber> {
  const response = await fetch(preferenceFormUrl(tokenValue), {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'omit',
    body: JSON.stringify({
      emailChannel: submission.emailChannel,
      smsChannel: submission.smsChannel,
      ipAddress: submission.ipAddress,
      userAgent: submission.userAgent,
      urlLocation: submission.urlLocation,
    }),
  });

  if (!response.ok) {
    throw new Error(
      await readErrorMessage(response, 'Unable to save preferences'),
    );
  }

  return await response.json();
}
